import { useCallback } from 'react';
import { isUnlikelyShift } from '~/components/Request/multiday/utils';
import { IToggleControls } from '~/hooks/useToggle';
import { ErrorType } from './Types';

interface IUseUnlikelyShiftValidationProps {
  controls: IToggleControls;
}

export const useUnlikelyShiftValidation = ({ controls }: IUseUnlikelyShiftValidationProps) => {
  const doValidate = useCallback(
    (newArrival: string, newDeparture: string): ErrorType | undefined => {
      if (isUnlikelyShift(newArrival, newDeparture)) {
        controls.setOn();
        return ErrorType.UnlikelyShifts;
      }

      return undefined;
    },
    [controls],
  );

  return {
    doValidate,
  };
};
